import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'mCollectorSurvay';
  release="1.0.2";
  private release_version:String = "26-03-2026-00"
}
